type Validator = (value: string) => boolean;

export const matchSSN: Validator = (value: string) => {
    return /^\d{3}\-\d{2}\-\d{4}$/.test(value);
};

export const matchVIN: Validator = (value: string) => {
    return /^(\d|[a-zA-Z]){17}$/.test(value);
};

export const matchAccountNumber: Validator = (value: string) => {
    return /^(\d|[0-9]){8,14}$/.test(value);
};

export const matchOnlyNumber: Validator = (value: string) => {
    return /^\d+$/.test(value);
};

export const matchCommaSeparatedNumber: Validator = (value: string) => {
    return /^\d+(,\d+)*$/.test(value);
};

export const matchVINWithIOLetter: Validator = (value: string) => {
    return /^[a-hj-npr-z0-9]{17}$/i.test(value);
};
